<template>
  <div>
    <div>
      <main role="main">
        <div id="ScrollSec_1"></div>
        <div
          class="page-content"
          v-if="
            handpickSuggetionList.length > 0 &&
            mydetail.is_membership_subscribed == 'Y'
          ">
          <div class="container py-md-5 py-4">
            <div class="row justify-content-center" v-if="!loader">
              <div class="col-lg-10">
                <div class="row align-items-center mb-4">
                  <div class="col-md-6">
                    <h2 class="page-title mb-md-0 mb-3">
                      <a class="cursor-pointer" v-on:click="$router.go(-1)"
                        ><img
                          src="/images/back-arrow.svg"
                          width="20"
                          alt=""
                          class="me-2"
                      /></a>
                      <p v-if="id">
                        <span>Profile</span>
                      </p>
                      <p v-else>
                        <span>Handpick suggestions </span><br />
                        <span>from nimbalkar</span>
                      </p>
                    </h2>
                  </div>
                  <div class="col-md-2 text-md-end text-center">
                    <div class="font-bold mb-3">
                      {{ current_profile + 1 }}/{{
                        handpickSuggetionList.length
                      }}
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div
                      class="d-flex suggestion-prof-nav align-items-center justify-content-md-end justify-content-center">
                      <a
                        v-if="current_profile + 1 != 1"
                        v-on:click="
                          current_profile + 1 != 1
                            ? getpreviousProfile('PREVIOUS')
                            : ''
                        "
                        class="me-2 prev-profile prof-nav-btn"
                        :class="current_profile + 1 != 1 ? 'current' : ''"
                        :style="
                          current_profile + 1 != 1 ? 'cursor:pointer' : ''
                        "
                        ><span></span
                        ><i
                          class="fa fa-angle-left"
                          aria-hidden="true"
                          style="font-size: 17px"
                          >Prev</i
                        ></a
                      >
                      <div
                        class="profile-img current"
                        v-if="current_profile + 1 != 1">
                        <img
                          :src="
                            current_image ? current_image : '/img/profile.svg'
                          "
                          width="40"
                          alt="" />
                      </div>
                      <div
                        class="profile-img current"
                        v-if="
                          current_profile + 1 !=
                          this.handpickSuggetionList.length
                        ">
                        <img
                          :src="next_image ? next_image : '/img/profile.svg'"
                          width="40"
                          alt="" />
                      </div>
                      <a
                        v-if="
                          current_profile + 1 !=
                          this.handpickSuggetionList.length
                        "
                        v-on:click="
                          current_profile == handpickSuggetionList.length
                            ? ''
                            : getpreviousProfile('NEXT')
                        "
                        class="ms-2 next-profile prof-nav-btn"
                        :class="
                          current_profile + 1 == handpickSuggetionList.length
                            ? ''
                            : 'current'
                        "
                        :style="
                          current_profile + 1 == handpickSuggetionList.length
                            ? ''
                            : 'cursor:pointer'
                        "
                        ><i
                          class="fa fa-angle-right"
                          aria-hidden="true"
                          style="font-size: 17px"
                          >Next</i
                        ><span></span
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-3 mb-4">
                    <div
                      id="suggesteProfileSlider"
                      class="carousel slide suggesteProfileSlider"
                      data-bs-ride="carousel"
                      data-bs-interval="false">
                      <div
                        class="carousel-inner rounded-l cursor-pointer"
                        v-if="detail.user_images.length">
                        <div
                          class="carousel-item mb-3"
                          v-for="(data, index) in detail.user_images"
                          :key="index"
                          :class="index == 0 ? 'active' : ''">
                          <img
                            v-on:click="showUserGallery(index)"
                            :src="data.image ? data.image : 'img/profile.svg'"
                            class="photos" />
                        </div>
                      </div>
                      <img
                        v-if="detail.handPicked"
                        src="/images/sugested-label.svg"
                        alt="Sugested"
                        class="corner-label"
                        width="120"
                        height="121" />
                    </div>
                    <div
                      id="suggesteProfileSlider"
                      class="carousel slide suggesteProfileSlider"
                      data-bs-ride="carousel"
                      data-bs-interval="false"
                      v-if="detail.user_images.length == 0">
                      <div class="carousel-inner rounded-l cursor-pointer">
                        <div class="carousel-item active">
                          <img
                            src="/img/profile.svg"
                            class="photos"
                            alt="..." />
                        </div>
                      </div>
                      <img
                        v-if="detail.handPicked"
                        src="/images/sugested-label.svg"
                        alt="Sugested"
                        class="corner-label"
                        width="120"
                        height="121" />
                    </div>
                    <div
                      class="text-center mb-5 position-relative"
                      v-if="detail.user_images.length > 1">
                      <button
                        class="carousel-control-prev"
                        type="button"
                        data-bs-target="#suggesteProfileSlider"
                        data-bs-slide="prev"
                        v-on:click="PrevIndex()">
                        <span
                          class="carousel-control-prev-icon"
                          aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <span
                        >{{ indexCount }}/{{ detail.user_images.length }}</span
                      >
                      <button
                        class="carousel-control-next"
                        type="button"
                        data-bs-target="#suggesteProfileSlider"
                        data-bs-slide="next"
                        v-on:click="NextIndex()">
                        <span
                          class="carousel-control-next-icon"
                          aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                    <p
                      style="display: none"
                      class="text-brand text-center"
                      v-if="!detail.handPicked_date">
                      Suggested Date:
                      {{
                        this.$helperService.getFormatedDate(
                          detail.handPicked_date
                        )
                      }}
                    </p>
                    <button
                      v-if="!detail.hasViewContact"
                      v-on:click="showRemmaingtactModel()"
                      class="btn btn-outline-brand-1 mt-2 mb-3 w-100">
                      <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                      View Contact
                    </button>
                    <button
                      v-if="detail.hasViewContact"
                      v-on:click="showRemmaingtactModel()"
                      class="btn btn-brand-1 mt-2 mb-3 w-100">
                      <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                      View Contact
                    </button>
                    <button
                      type="button"
                      class="btn btn-brand-1 w-100 mb-2"
                      v-if="!detail.hasSentIntrest"
                      v-on:click="sendIntrest()">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Send interest
                    </button>
                    <button
                      type="button"
                      class="btn btn-brand-1 w-100 mb-2"
                      v-if="detail.hasSentIntrest"
                      v-on:click="notIntrested()">
                      <i
                        class="fa fa-paper-plane font-20 me-2"
                        aria-hidden="true"></i>
                      Cancel Interest
                    </button>
                    <div
                      class="btn-group w-100"
                      role="group"
                      aria-label="Basic checkbox toggle button group"
                      v-if="!detail.hasShortListed">
                      <input
                        type="checkbox"
                        class="btn-check"
                        :id="'btncheck' + index"
                        autocomplete="off" />
                      <label
                        class="btn btn-outline-brand-1 mb-2 w-100"
                        :for="'btncheck' + index"
                        v-on:click="shortlist()"
                        ><i
                          class="fa fa-heart font-20 me-2"
                          aria-hidden="true"></i>
                        Shortlist</label
                      >
                    </div>
                    <button
                      type="button"
                      class="btn btn-brand-1 w-100 mb-2"
                      v-if="detail.hasShortListed"
                      v-on:click="removeShortlisted()">
                      <i
                        class="fa fa-heart font-20 me-2"
                        aria-hidden="true"></i>
                      Shortlisted
                    </button>
                    <div v-click-outside="showDropDown" class="dropdown">
                      <button
                        type="button"
                        :class="
                          detail.hasBlocked || detail.hasReported
                            ? 'btn-brand-1'
                            : 'btn-outline-brand-1'
                        "
                        class="btn w-100 dropdown-toggle"
                        id="dropdownMore"
                        @click="
                          this.isClick = true;
                          this.isShowMore = !this.isShowMore;
                        ">
                        <i
                          class="fa fa-ellipsis-v font-20 me-2"
                          aria-hidden="true"></i>
                        More
                      </button>
                      <ul
                        :class="
                          isShowMore == true
                            ? 'dropdown-menu show'
                            : 'dropdown-menu'
                        ">
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click="showSharePopup(detail.uuid)"
                            ><i class="fa fa-share-alt" aria-hidden="true"></i>
                            Share Profile</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item cursor-pointer"
                            v-if="!detail.hasBlocked"
                            v-on:click="blockUser()"
                            ><i class="fa fa-ban" aria-hidden="true"></i> Block
                            User</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item cursor-pointer"
                            v-if="detail.hasBlocked"
                            v-on:click="unblockUser()"
                            ><i class="fa fa-ban" aria-hidden="true"></i>
                            Unblock</a
                          >
                        </li>
                        <li>
                          <a
                            v-if="detail.hasReported == 0"
                            class="dropdown-item cursor-pointer"
                            v-on:click="showReportUser()"
                            ><i class="fa fa-flag" aria-hidden="true"></i>
                            Report This User</a
                          >
                          <a
                            v-if="detail.hasReported"
                            class="dropdown-item cursor-pointer"
                            style="color: red; font-weight: 401"
                            ><i
                              class="fa fa-flag"
                              aria-hidden="true"
                              style="color: red"></i>
                            Already Reported</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-9 position-relative">
                    <nav
                      style="display: none"
                      id="navbar_scrolltab"
                      class="navbar navbar-light bg-white p-0 fixed-scroll-tab">
                      <ul class="nav nav-pills mb-3 tab-style-1 w-100">
                        <li class="nav-item">
                          <a class="nav-link" href="#ScrollSec_1"
                            >Personal details</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#ScrollSec_2"
                            >family details</a
                          >
                        </li>
                        <li class="nav-item" v-if="detail.expectation">
                          <a class="nav-link" href="#ScrollSec_3"
                            >Expectations</a
                          >
                        </li>
                      </ul>
                    </nav>

                    <div
                      data-bs-spy="scroll"
                      data-bs-target="#navbar_scrolltab"
                      data-bs-offset="90"
                      class="scrollspy-example form-style"
                      tabindex="0">
                      <h3 class="font-bold font-18 mb-3 gery-bar">
                        Personal Details
                      </h3>
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Registration No.</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.registration_no
                                    ? detail.registration_no
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>

                          <!-- <div
                          class="row"
                          v-if="mydetail.is_membership_subscribed == 'Y'"
                        >
                          <div class="col-lg-4 col-md-5">
                            <label>Name</label>
                          </div>
                          <div class="col-lg-8 col-md-7" style="word-break: break-all !important;">
                            <p class="font-medium" >
                              {{ detail.first_name ? detail.first_name : "" }}
                              {{ detail.middle_name ? detail.middle_name : "" }}
                              {{ detail.last_name ? detail.last_name : "" }}
                            </p>
                          </div>
                        </div> -->
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Surname</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium pink-clr">
                                {{ detail.last_name ? detail.last_name : "-" }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Marital Status</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.marital_status
                                    ? detail.marital_status.name
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Date of Birth</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.dob
                                    ? $helperService.getFormatedDate(detail.dob)
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Height</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.height
                                    ? $helperService.getHeight(detail.height)
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Body Structure</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.body_structure
                                    ? detail.body_structure.name
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Blood Group</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.blood_group ? detail.blood_group : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Skin Tone</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.scan_tone ? detail.scan_tone.name : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Diet</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{ detail.diet ? detail.diet.name : "-" }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Education</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.education_courses
                                    ? detail.education_courses
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-5">
                              <label>Gun Milan</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.patrika_gun ? detail.patrika_gun : "NA"
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Occupational Details</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.occupation_details
                                    ? detail.occupation_details
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Annual Income (Lakh)</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.annual_income ||
                                  detail.annual_income == 0
                                    ? $helperService.kFormatter(
                                        detail.annual_income
                                      )
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Work Location</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.working_place_goan
                                    ? detail.working_place_goan + " , "
                                    : ""
                                }}
                                {{
                                  detail.working_place_taluka
                                    ? detail.working_place_taluka.name
                                    : ""
                                }}
                              </p>
                              <p
                                v-if="
                                  !detail.working_place_goan &&
                                  !detail.working_place_taluka
                                ">
                                -
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <label>Other Information</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.other_info ? detail.other_info : "-"
                                }}
                              </p>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-6">
                              <label>Birth Time & Birth District</label>
                            </div>
                            <div class="col-lg-6">
                              <p class="font-medium">
                                {{
                                  detail.birth_time
                                    ? $helperService.getFormatedTime(
                                        detail.birth_time
                                      )
                                    : "-"
                                }}
                                {{
                                  detail.birth_district
                                    ? detail.birth_district.name
                                    : "-"
                                }}
                              </p>
                            </div>
                          </div>

                          <!-- Family Details  -->
                          <div class="mb-4" id="ScrollSec_2">
                            <!-- <div class="row">
                          <div class="col-lg-4 col-md-5">
                            <label>Gun Milan</label>
                          </div>
                          <div class="col-lg-8 col-md-7">
                            <p class="font-medium">
                              {{ detail.gan ? detail.gan.name : "-" }}
                            </p>
                          </div>
                        </div> -->
                            <div class="row mt-3">
                              <div class="col-lg-6">
                                <label>Mangal</label>
                              </div>
                              <div class="col-lg-6">
                                <p class="font-medium">
                                  {{
                                    detail.is_mangal
                                      ? detail.is_mangal == "Y"
                                        ? "Yes"
                                        : detail.is_mangal == "N"
                                        ? "No"
                                        :  $helperService.getTitleCase(
                                          detail.is_mangal.replaceAll('_',' ')
                                          )
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6">
                                <label>Horoscope Details</label>
                              </div>
                              <div class="col-lg-6">
                                <p class="font-medium">
                                  {{
                                    detail.raas && detail.raas.name
                                      ? detail.raas.name + ","
                                      : ""
                                  }}
                                  {{
                                    detail.nakshatra && detail.nakshatra.name
                                      ? detail.nakshatra.name + ","
                                      : ""
                                  }}
                                  {{
                                    detail.charan && detail.charan.name
                                      ? detail.charan.name + ","
                                      : ""
                                  }}
                                  {{
                                    detail.nadi && detail.nadi.name
                                      ? detail.nadi.name + ","
                                      : "-"
                                  }}

                                  {{
                                    detail.gan && detail.gan.name
                                      ? detail.gan.name
                                      : ""
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6">
                                <label>Devak</label>
                              </div>
                              <div class="col-lg-6">
                                <p class="font-medium">
                                  {{ detail.devak ? detail.devak : "-" }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6">
                                <label>Ready To move abroad</label>
                              </div>
                              <div class="col-lg-6">
                                <p class="font-medium">
                                  {{
                                    detail.ready_to_move_abrod
                                      ? detail.ready_to_move_abrod == "Y"
                                        ? "Yes"
                                        : "No"
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <h3 class="font-bold font-18 mb-3 gery-bar mx-2">
                          Family Details
                        </h3>
                        <div
                          class="row"
                          v-show="mydetail.is_membership_subscribed == 'Y'">
                          <div class="col-lg-3">
                            <label>Native Place</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="font-regular">Gaon:</span>&nbsp;
                              <span class="me-3">
                                {{
                                  detail.native_place_goan
                                    ? detail.native_place_goan
                                    : "-"
                                }}
                              </span>
                              <span class="font-regular">Taluka:</span>&nbsp;
                              <span class="me-3">
                                {{
                                  detail.native_place_taluka
                                    ? detail.native_place_taluka.name
                                    : "-"
                                }}
                              </span>
                              <span class="font-regular">Dist.:</span>&nbsp;
                              <span class="">
                                {{
                                  detail.native_place_district
                                    ? detail.native_place_district.name
                                    : "-"
                                }}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="row" style="display: none">
                          <div class="col-lg-3">
                            <label>Family Residence</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="font-regular">Gaon:</span>&nbsp;
                              <span class="me-3">
                                {{
                                  detail.family_details &&
                                  detail.family_details.goan
                                    ? detail.family_details.goan
                                    : "-"
                                }}
                              </span>
                              <span class="font-regular">Taluka:</span>&nbsp;
                              <span class="me-3">
                                {{
                                  detail.family_details &&
                                  detail.family_details.taluka
                                    ? detail.family_details.taluka.name
                                    : "-"
                                }}
                              </span>
                              <span class="font-regular">Dist.:</span>&nbsp;
                              <span class="">
                                {{
                                  detail.family_details &&
                                  detail.family_details.district
                                    ? detail.family_details.district.name
                                    : "-"
                                }}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <label>Father Occupation</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="me-3">{{
                                detail.family_details &&
                                detail.family_details.father_occuption
                                  ? detail.family_details.father_occuption
                                  : "-"
                              }}</span>
                              <span class="">
                                {{
                                  detail.family_details &&
                                  detail.family_details.father_occuption_place
                                    ? detail.family_details
                                        .father_occuption_place
                                    : ""
                                }}</span
                              >
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <label>Mother Occupation</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="me-3">
                                {{
                                  detail.family_details &&
                                  detail.family_details.mother_occuption
                                    ? detail.family_details.mother_occuption
                                    : "-"
                                }}</span
                              >
                              <span class="">
                                {{
                                  detail.family_details &&
                                  detail.family_details.mother_occuption_place
                                    ? detail.family_details
                                        .mother_occuption_place
                                    : ""
                                }}</span
                              >
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 mb-3">
                            <label class="font-bold"
                              >Brother/Sister Details</label
                            >
                          </div>
                          <!-- <div class="col-lg-8 col-md-7">
                          <p class="">
                            (If sister is married, mention surname only)
                          </p>
                        </div> -->
                        </div>
                        <div class="table-wrap mb-3 table-responsive px-0">
                          <table
                            class="table table-style-1 table-responsive table-striped table-hover text-center"
                            id="sorting_tbl">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Married?</th>
                                <th>Education</th>
                                <th>Occup.</th>

                                <th>Place</th>
                                <th>Birth Year</th>
                                <th>Hgt</th>
                                <th>Rel.</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in detail.family_members"
                                :key="index">
                                <td>{{ data.name ? data.name : "-" }}</td>
                                <td>
                                  {{
                                    data.is_married
                                      ? data.is_married == "Y"
                                        ? "Yes"
                                        : "No"
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{ data.education ? data.education : "-" }}
                                </td>
                                <td>
                                  {{ data.occupation ? data.occupation : "-" }}
                                </td>

                                <td>
                                  {{
                                    data.working_place
                                      ? data.working_place
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{ data.birth_year ? data.birth_year : "-" }}
                                </td>
                                <td>
                                  {{
                                    data.height
                                      ? $helperService.getHeight(data.height)
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    data.gender
                                      ? data.gender == "M"
                                        ? "Bro"
                                        : "Sis"
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="row">
                          <div class="col-lg-3">
                            <label class="">Mama’s Surname</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium">
                              <span class="me-4">{{
                                detail.family_details &&
                                detail.family_details.mama_surname
                                  ? detail.family_details.mama_surname
                                  : "-"
                              }}</span>
                              <span class="me-4 font-regular">
                                <span
                                  v-if="
                                    detail.family_details &&
                                    detail.family_details.mama_native_place
                                  ">
                                  Native Place
                                </span>
                                <span class="font-medium">{{
                                  detail.family_details &&
                                  detail.family_details.mama_native_place
                                    ? detail.family_details.mama_native_place
                                    : "-"
                                }}</span></span
                              >
                              <span
                                class="font-regular"
                                v-if="
                                  detail.family_details &&
                                  detail.family_details.mama_taluka_place
                                ">
                                Taluka
                                <span class="font-medium">{{
                                  detail.family_details &&
                                  detail.family_details.mama_taluka_place
                                    ? detail.family_details.mama_taluka_place
                                    : "-"
                                }}</span></span
                              >
                            </p>
                          </div>
                        </div>

                        <!-- style="max-height: 150px; overflow: scroll" -->
                        <div class="row">
                          <div class="col-lg-3">
                            <label class="">Relatives </label>
                          </div>
                          <div class="col-lg-9">
                            <div>
                              <p
                                class="font-medium"
                                v-for="(data, index) in detail.relatives"
                                :key="index">
                                <span
                                  v-if="detail.relatives.length > 0"
                                  class="me-4">
                                  {{ data.surname ? data.surname : "" }}
                                  <span
                                    class="font-medium"
                                    v-show="
                                      mydetail.is_membership_subscribed == 'Y'
                                    ">
                                    {{
                                      data.goan ? " - " + data.goan : ""
                                    }}</span
                                  ></span
                                >
                              </p>
                            </div>
                            <p
                              class="font-medium"
                              v-if="detail.relative.length == 0">
                              -
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="" id="ScrollSec_3">
                        <div class="row">
                          <div class="col-lg-3">
                            <label class="">Properties </label>
                          </div>
                          <div class="col-lg-9">
                            <span
                              v-for="(data, index) in detail.properties"
                              :key="index">
                              <p
                                v-if="data.details || data.place"
                                class="font-medium">
                                <span
                                  v-if="detail.properties.length > 0"
                                  class="">
                                  {{ data.details ? data.details : "" }}
                                  <span
                                    class="font-medium"
                                    v-show="
                                      mydetail.is_membership_subscribed == 'Y'
                                    ">
                                    {{
                                      data.place ? " - " + data.place : ""
                                    }}</span
                                  ></span
                                >
                              </p>
                            </span>
                            <p
                              class="font-medium"
                              v-if="detail.properties.length == 0">
                              -
                            </p>
                          </div>
                        </div>
                        <h3 class="font-bold font-18 mb-3 gery-bar">
                          Expectations
                        </h3>
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label> Marital Status</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                            <p class="font-medium">{{ marrital_status }}</p>
                          </div>
                        </div>
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Expected Body Structure</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ body_structure }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Expected Diet</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ diet }}</p>
                          </div>
                        </div> -->

                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Occupation</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ occupation_type }}</p>
                          </div>
                        </div> -->

                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label> Birth Years</label>
                          </div>

                          <div class="col-lg-9">
                            <p class="font-medium">
                              {{
                                detail.expectation &&
                                detail.expectation.birth_year_from
                                  ? detail.expectation.birth_year_from + " to "
                                  : ""
                              }}

                              {{
                                detail.expectation &&
                                detail.expectation.birth_year_to
                                  ? detail.expectation.birth_year_to
                                  : "-"
                              }}
                            </p>
                            <!-- <p class="font-medium" v-if="!detail.expectation">-</p> -->
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label> Height</label>
                          </div>
                          <div class="col-lg-9" v-if="!detail.expectation">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                          <div class="col-lg-3" v-if="detail.expectation">
                            <p class="font-medium">
                              {{
                                $helperService.getHeight(
                                  detail.expectation.height_from
                                )
                                  ? $helperService.getHeight(
                                      detail.expectation.height_from
                                    ) + "- " // detail.expectation.height_from + // " cm to "
                                  : "- "
                              }}

                              {{
                                $helperService.getHeight(
                                  detail.expectation.height_to
                                )
                                  ? $helperService.getHeight(
                                      detail.expectation.height_to
                                    ) // ) + // "- " + // detail.expectation.height_to + // " cm"
                                  : ""
                              }}
                            </p>
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label>Patrika Matching</label>
                          </div>
                          <div class="col-lg-9">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                            <p class="font-medium">
                              {{
                                detail.expectation &&
                                detail.expectation.patrika_match == "Y"
                                  ? "YES"
                                  : detail.expectation &&
                                    detail.expectation.patrika_match == "ALL"
                                  ? "Flexible"
                                  : detail.expectation &&
                                    detail.expectation.patrika_match == "N"
                                  ? "NO"
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div>
                        <!-- <div class="row mb-2">
                          <div class="col-lg-4 col-md-6">
                            <label>Preferred Working Cities</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">
                              {{ working_city_name ? working_city_name : "-" }}
                              {{ working_country_name }}
                            </p>
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                        </div> -->
                        <!-- <div class="row mb-2">
                          <div class="col-lg-4 col-md-6">
                            <label>Preferred Native Places</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                            <p class="font-medium">
                              {{ native_district ? native_district : "-" }}
                            </p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Family Residencial Taluka</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">
                              {{ family_residence }}
                            </p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Education Group</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ education_group }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Move to Abroad</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ move_to_abroad }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Per.</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ personality }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Echo Status</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ echo_status }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row">
                          <div class="col-lg-4 col-md-6">
                            <label>Relation</label>
                          </div>
                          <div class="col-lg-8 col-md-6">
                            <p class="font-medium">{{ relation }}</p>
                          </div>
                        </div> -->
                        <!-- <div class="row mb-3">
                          <div class="col-lg-4 col-md-6">
                            <label>Expected Education</label>
                          </div>
                          <div
                            class="col-lg-8 col-md-6"
                            v-if="!detail.expectation"
                          >
                            <p class="font-medium" v-if="!detail.expectation">
                              -
                            </p>
                          </div>
                          <div
                            class="col-lg-8 col-md-6"
                            v-if="detail.expectation"
                          >
                            <p class="font-medium">
                              {{
                                detail.expectation.expected_educations
                                  ? detail.expectation.expected_educations
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div> -->
                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label>Expectations</label>
                          </div>
                          <div class="col-lg-9" v-if="!detail.expectation">
                            <p class="font-medium">-</p>
                          </div>
                          <div class="col-lg-9" v-if="detail.expectation">
                            <p class="font-medium">
                              {{
                                detail.expectation.occupation_other_expectations
                                  ? detail.expectation
                                      .occupation_other_expectations
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ErrorComponent @retry="getUserDetail()" ref="errorComponent" />
          </div>
        </div>
        <div
          v-if="
            handpickSuggetionList.length == 0 &&
            mydetail.is_membership_subscribed == 'Y'
          "
          class="text-center"
          style="height: 600px">
          <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
            <h3 style="margin-top: 300px">
              <strong>No Suggestions are Available</strong>
            </h3>
          </div>
        </div>
        <div
          v-if="
            mydetail.is_membership_subscribed == null ||
            mydetail.is_membership_subscribed == 'N'
          "
          class="text-center"
          style="height: 600px">
          <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
            <h3 style="margin-top: 200px">
              <div>
                <strong>Buy a plan to avail this services</strong>
              </div>
              <div style="margin-top: 15px">
                <router-link
                  to="/membership-plans"
                  class="btn btn-brand-1 btn-block"
                  style="background-color: green !important; text-transform: none;!important">
                  View Membership Plan</router-link
                >
              </div>
            </h3>
          </div>
        </div>
      </main>

      <MainFooter />

      <ImageGalleryModel ref="galleryModel">
        <div
          class="modal-dialog photos-gallery modal-dialog-centered"
          style="max-width: 500px">
          <div class="modal-content">
            <div class="modal-header">
              <a
                class="close text-danger btn-pos"
                style="opacity: 1"
                v-on:click="$refs.galleryModel.closeModal()"
                type="button">
                <img
                  src="/images/close-btn.png"
                  width="25"
                  height="25"
                  style="background: #fff; border-radius: 100px" />
              </a>
            </div>
            <div class="modal-body">
              <div>
                <div class="text-center">
                  <img
                    v-if="selected_image"
                    class="modal-box-img"
                    id="preview"
                    :src="selected_image"
                    width="600"
                    height="600" />
                </div>
              </div>
              <div class="image-gallary -d-flex">
                <div
                  class="col-2 me-2"
                  v-for="(data, index) in detail.user_images"
                  :key="index">
                  <div v-if="data.image" v-on:click="changeImage(data.image)">
                    <img :src="data.image" width="50" height="50" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ImageGalleryModel>
      <TextModal ref="reportModal">
        <div class="modal-content">
          <div class="modal-header px-md-5 border-0">
            <div class="row">
              <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
              <button
                type="button"
                class="btn-close"
                v-on:click="$refs.reportModal.closeModal()"></button>
            </div>
          </div>
          <div class="modal-body px-4">
            <h5 class="modal-title font-22 mb-0 text-center mb-3">Report</h5>
            <Form ref="reportForm" @submit="reportUser()">
              <div class="floating-form mb-4">
                <div
                  class="floating-form-group mt-4 mb-2"
                  style="height: 130px">
                  <Field
                    as="textarea"
                    type="text"
                    rows="4"
                    style="width: 100%"
                    name="message"
                    rules="required:message"
                    :validateOnInput="true"
                    v-model="reportObj.message" />

                  <label for="message"
                    >Please write your problem/suggestion</label
                  >
                  <span class="text-danger">*</span>
                </div>
                <ErrorMessage name="message" class="text-danger" />
              </div>
              <div class="text-center">
                <button class="btn btn-brand-1" id="submit-Button10">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </TextModal>

      <TextModal ref="viewMembershipPlan">
        <div>
          <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
            <div class="col-1" style="text-align-last: end"></div>
          </div>
          <div class="modal-body pt-0 form-style">
            <div class="row">
              <button
                type="button"
                class="btn-close"
                style="
                  margin-left: auto;
                  margin-top: -58px;
                  margin-right: -10px;
                "
                v-on:click="$refs.viewMembershipPlan.closeModal()"></button>
            </div>
            <div class="form-group">
              <h4 class="text-center">You are a free member</h4>
              <p>
                Buy a paid membership to see contact no. & some hidden
                information
              </p>
            </div>
            <div class="text-center">
              <router-link
                to="/membership-plans"
                class="btn btn-brand-1 btn-block">
                View membership plan
              </router-link>
            </div>
          </div>
        </div>
      </TextModal>
      <TextModal ref="remainingContacts">
        <div>
          <div class="row border-0 text-align-last-center">
            <div class="col-1" style="text-align-last: end"></div>
          </div>
          <div class="modal-body p-3 form-style">
            <div class="row">
              <button
                type="button"
                class="btn-close"
                style="margin-left: auto"
                v-on:click="$refs.remainingContacts.closeModal()"></button>
            </div>
            <div class="form-group">
              <h4 class="text-center">View Contact</h4>
              <p class="text-center">
                Your Total Remaining Contact View is -
                {{ remaining_contact_view_count }}
              </p>
            </div>
            <div class="text-center">
              <button
                type="button"
                class="btn btn-brand-1 w-100"
                v-on:click="showContactModel()">
                View Contact
              </button>
            </div>
          </div>
        </div>
      </TextModal>
      <ShareModal ref="shareModal" />
      <ConteactViewModel ref="ConteactViewModel" />
    </div>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import ConteactViewModel from "@/components/ConteactViewModel";
import TextModal from "@/components/TextModal.vue";
import ImageGalleryModel from "@/components/ImageGalleryModel.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import ShareModal from "@/views/SocialShare/ShareModal.vue";
export default {
  name: "HandpickSuggestions",
  components: {
    ErrorComponent,
    ConteactViewModel,
    TextModal,
    ImageGalleryModel,
    Form,
    Field,
    ShareModal,
    ErrorMessage,
  },
  data() {
    return {
      loader: false,
      uuid: "",
      remaining_contact_view_count: 0,
      contentDetail: {},
      handpickSuggetionList: [],
      detail: {
        user_images: [],
      },
      isClick: false,
      isShowMore: false,
      mydetail: {
        is_membership_subscribed: "",
      },
      indexCount: 1,
      report_id: "",
      current_profile: "",
      current_image: "",
      selected_image: "",
      next_image: "",
      marrital_status: "",
      working_country_name: "",
      family_residence: "",
      working_country: "",
      native_district: "",
      working_city_name: "",
      reportObj: {},
      url: window.location.href,
      count: "",
      showingFullText: false,
      showingFullIngredients: false,
      body: "",
      ingredients: "",
      // All: this.$route.query.All,
      type: this.$route.query.type,
    };
  },
  mounted() {
    this.getMeCall();
    this.getHandPickSuggetion();
    window.scrollTo(-1000, -1000);
    document.getElementById('navbarSupportedContent').classList.remove('show');
  },
  methods: {
    changeImage(image) {
      this.selected_image = "";
      this.selected_image = image;
      document.getElementById("preview").src = image;
    },
    showSharePopup(uuid) {
      this.url = window.location.href;
      var url = this.url.replaceAll(
        "/handpick-suggestions",
        "/profile-view/" + uuid
      );
      this.url = url;
      this.$refs.shareModal.showModal(this.url, "Profile");
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.mydetail = res;
          if (this.mydetail.is_membership_subscribed == null) {
            this.mydetail.is_membership_subscribed = "N";
          }
          this.$store.commit("setUser", res);
        })
        .catch(() => {});
    },
    showDropDown() {
      if (this.isClick) {
        this.isClick = false;
      } else {
        this.isShowMore = false;
      }
    },

    smsEmailUserDetails(uuid) {
      this.$api
        .getAPI({
          _action: "/email-detail/" + uuid,
        })
        .then(() => {
          this.$notify({
            type: "success",
            text: "User details are successfully sent to your registered email and mobile number",
          });
          this.$refs.viewContactmodel.closeModal();
        })
        .catch(() => {});
    },
    showRemmaingtactModel(uuid) {
      this.$refs.errorComponent.updateFormLoader(true);
      if (uuid) {
        this.uuid = uuid;
      }
      this.$api
        .getAPI({
          _action: "/remmaing-contact-detail/" + this.uuid,
        })
        .then((res) => {
          this.$refs.errorComponent.updateFormLoader(false);
          if (res.contact_view && res.contact_view > 0) {
            this.remaining_contact_view_count = res.contact_view;
            this.$refs.remainingContacts.showModal();
          } else if (res.already_viewed && res.already_viewed == 1) {
            this.contentDetail = res;
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          } else {
            this.$refs.viewMembershipPlan.showModal();
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    showContactModel() {
      this.$refs.remainingContacts.closeModal();
      this.$api
        .getAPI({
          _action: "/contact-detail/" + this.uuid,
        })
        .then((res) => {
          if (res) {
            this.contentDetail = res;
            this.$refs.remainingContacts.closeModal();
            this.getUserDetail(this.uuid);
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          }
        })
        .catch(() => {});
    },
    getpreviousProfile(type) {
      if (type == "PREVIOUS") {
        this.current_image = "";
        this.current_profile = this.current_profile - 1;
      } else {
        this.next_image = "";
        this.current_profile = this.current_profile + 1;
      }
      if (this.current_profile != 0) {
        if (this.handpickSuggetionList.length - 1 >= this.current_profile - 1) {
          this.current_image =
            this.handpickSuggetionList[this.current_profile - 1].image;
        }
      }

      if (this.handpickSuggetionList.length - 1 >= this.current_profile + 1) {
        this.next_image =
          this.handpickSuggetionList[this.current_profile + 1].image;
      }
      this.getUserDetail(this.handpickSuggetionList[this.current_profile].uuid);
      this.uuid = this.handpickSuggetionList[this.current_profile].uuid;
    },
    getHandPickSuggetion() {
      this.$api
        .getAPI({
          _action: "/user-sugestion/list",
        })
        .then((res) => {
          this.handpickSuggetionList = res.list;
          if (this.handpickSuggetionList.length > 0) {
            this.current_profile = 0;
            // this.current_image = this.handpickSuggetionList[0].image;
            if (this.handpickSuggetionList.length > 1) {
              this.next_image = this.handpickSuggetionList[1].image;
            }
            this.uuid = this.handpickSuggetionList[0].uuid;
            this.getUserDetail(this.handpickSuggetionList[0].uuid);
          }
        })
        .catch(() => {});
    },
    getUserDetail(uuid) {
      this.detail = {};
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }

      this.$api
        .getAPI({
          _action: "/profile-detail/" + uuid,
        })
        .then((res) => {
          this.loader = false;
          this.detail = res;
          if (
            this.detail.expectation &&
            this.detail.expectation.marital_status.length > 0
          ) {
            var array = [];
            for (var i in this.detail.expectation.marital_status) {
              array.push(this.detail.expectation.marital_status[i].name);
            }
            this.marrital_status = array.toString();
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.working_country.length > 0
          ) {
            var array_6 = [];
            for (var a in this.detail.expectation.working_country) {
              array_6.push(
                ` ${this.detail.expectation.working_country[a].name}`
              );
            }
            this.working_country_name = array_6.toString();
          }

          if (
            this.detail.expectation &&
            this.detail.expectation.working_city.length > 0
          ) {
            var array_7 = [];
            for (var b in this.detail.expectation.working_city) {
              array_7.push(` ${this.detail.expectation.working_city[b].name}`);
            }
            this.working_city_name = array_7.toString();
          }
          if (
            this.detail.expectation &&
            this.detail.expectation.family_residence.length > 0
          ) {
            var array_9 = [];
            for (var d in this.detail.expectation.family_residence) {
              array_9.push(
                ` ${this.detail.expectation.family_residence[d].name}`
              );
            }
            this.family_residence = array_9.toString();
          }

          if (
            this.detail.expectation &&
            this.detail.expectation.native_district.length > 0
          ) {
            var array_10 = [];
            for (var e in this.detail.expectation.native_district) {
              array_10.push(
                ` ${this.detail.expectation.native_district[e].name}`
              );
            }
            this.native_district = array_10.toString();
          }

          if (this.$refs.errorComponent) {
            this.loader = false;
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.updateListLoader(false);
        });
    },
    PrevIndex() {
      if (this.indexCount == 1) {
        this.indexCount = this.detail.user_images.length;
      } else {
        this.indexCount = this.indexCount - 1;
      }
    },
    NextIndex() {
      if (this.indexCount == this.detail.user_images.length) {
        this.indexCount = 1;
      } else {
        this.indexCount = this.indexCount + 1;
      }
    },
    shortlist() {
      var obj = {};
      if (this.detail) {
        obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      } else {
        return;
      }
      if (obj.to_user_id) {
        this.$api
          .postAPI({
            _action: "/short-list",
            _body: obj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            return (this.detail.hasShortListed = 1);
          })
          .catch(() => {});
      }
    },
    sendIntrest() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (this.detail.hasSentIntrest = 1);
        })
        .catch(() => {});
    },
    notIntrested() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + obj.to_user_id,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (this.detail.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
    blockUser() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .postAPI({
          _action: "/block-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (this.detail.hasBlocked = 1);
        })
        .catch(() => {});
    },
    unblockUser() {
      var obj = {};
      obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      this.$api
        .postAPI({
          _action: "/unblock-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (this.detail.hasBlocked = 0);
        })
        .catch(() => {});
    },
    reportUser() {
      this.reportObj.to_user_id = this.report_id;
      this.$api
        .postAPI({
          _action: "/report-user",
          _body: this.reportObj,
          _buttonId: "submit-Button10",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.detail.hasReported = 1;
          this.$refs.reportModal.closeModal();
          this.changeTab(this.currentTab);
        })
        .catch(() => {});
    },
    removeShortlisted() {
      var obj = {};
      if (this.detail) {
        obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      } else {
        obj.to_user_id = this.detail.uuid ? this.detail.uuid : "";
      }
      if (obj.to_user_id) {
        this.$api
          .putAPI({
            _action: "/remove-shortlist/" + obj.to_user_id,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            return (this.detail.hasShortListed = 0);
          })
          .catch(() => {});
      }
    },
    showReportUser() {
      this.report_id = this.detail.uuid;
      this.$refs.reportForm.resetForm();
      this.$refs.reportModal.showModal();
    },
    showUserGallery(index) {
      if (this.detail.user_images.length > 0) {
        this.selected_image = this.detail.user_images[index].image;
      }
      this.$refs.galleryModel.showModal();
    },
  },
};
</script>

<style>
.font-medium {
  word-wrap: break-word;
  word-break: break-all;
}
</style>
